import { Event, EventService, Geogroup, Partner } from '@geovelo-frontends/commons';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from './query-keys';

async function fetchHighlightedEvents(
  partner: Partner,
  geogroup: Geogroup,
  onlyBannerEnabled: boolean,
  includeFinished: boolean,
): Promise<Event[] | null> {
  const availableEvents = await EventService.getAvailableEvents({
    partner,
    geogroupId: geogroup.id,
    page: 1,
    pageSize: 10,
    state: includeFinished ? ['running', 'future', 'finished'] : ['running', 'future'],
    excludeJoinedEvents: false,
    ...(onlyBannerEnabled ? { bannerEnabled: true } : {}),
    onlyPublic: true,
    ordering: '-start_datetime',
  });

  return availableEvents.length === 0 ? null : availableEvents;
}

export default function useHighlightedEventsQuery(
  partner: Partner | null | undefined,
  geogroup: Geogroup | null | undefined,
  {
    includeFinished = false,
    onlyBannerEnabled = true,
  }: { includeFinished?: boolean; onlyBannerEnabled?: boolean } = {},
) {
  return useQuery({
    queryKey: queryKeys.highlightedEvents.all(
      partner?.id,
      geogroup?.id,
      onlyBannerEnabled,
      includeFinished,
    ),
    queryFn: () =>
      fetchHighlightedEvents(
        partner as Partner,
        geogroup as Geogroup,
        onlyBannerEnabled,
        includeFinished,
      ),
    enabled: !!partner && !!geogroup,
    staleTime: Infinity,
  });
}
